import { school } from '@/assets/data/map.json'

export default {
  state: {
    schoolList: school
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/map.js